import type { AvatarProps as MuiAvatarProps } from "@mui/material";
import { Avatar as MuiAvatar } from "@mui/material";

function getInitials(name: string | undefined): string {
  if (!name) {
    return "";
  }

  const initials = name
    .trim()
    .split(/\s+/)
    .map((val) => val.at(0))
    .filter(Boolean);

  const first = initials.at(0) ?? "";
  const last = initials.length > 1 ? initials.at(-1) : "";
  return `${first}${last}`.toUpperCase();
}

export interface AvatarProps extends Omit<MuiAvatarProps, "children"> {
  name: string;
}

export function Avatar({ name, ...props }: AvatarProps) {
  return <MuiAvatar {...props}>{getInitials(name)}</MuiAvatar>;
}
